
    import '/vercel/path0/docs/demo/multiple-Portal.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"multiple-Portal","toc":"menu","filename":"docs/demo/multiple-Portal.md","lastUpdated":1767583902000,"nav":{"title":"Demo","path":"/demo"}};